import styled from 'styled-components'

import { AddToFavoritesButtonDesktop, ProductAttributes } from '~/components'
import theme from '~/truck/theme'

export const StyledAddToFavoritesButton = styled(AddToFavoritesButtonDesktop)<{ $visible: boolean }>`
  margin-top: ${theme.spacing.compact * 3}px;
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
`

export const StyledProductAttributes = styled(ProductAttributes)`
  margin-bottom: ${theme.spacing.relaxed}px;
`
